import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { IssueEntity } from './issue.entity';

@Index('issue__file__fk__file__id_fk', ['fkFileId'], {})
@Index('issue__file__fk_issue__id_fk', ['fkIssueId'], {})
@Entity('issue__file')
export class IssueFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	@ManyToOne(() => IssueEntity, (issue) => issue.issueFiles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;

	@ManyToOne(() => FileEntity, (file) => file.issueFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
